import { TournamentPage } from "../../types/tournamentTypes";
import { TournamentText } from "./TournamentText";

/**
 * Displays trivia for a tournament page, if it has any
 */
export function TournamentTrivia(props: { page: TournamentPage }) {
  if (!props.page.trivia || props.page.trivia.length === 0) return null;
  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Trivia</h3>
      <ul style={{ marginTop: 2 }}>
        {props.page.trivia.map((trivia, index) => (
          <li key={index}>
            <TournamentText text={trivia} />
          </li>
        ))}
      </ul>
    </div>
  );
}
